import android from "../static/icons/android.png";
import apple from "../static/icons/apple.png";
import css3 from "../static/icons/css3.png";
import html5 from "../static/icons/html5.png";
import java from "../static/icons/java.png";
import javascript from "../static/icons/javascript.png";
import mongodb from "../static/icons/mongodb.png";
import nodejs from "../static/icons/nodejs.png";
import react from "../static/icons/react.png";
import swift from "../static/icons/swift.png";
import database from "../static/icons/database.png";

export default function Utils() {
  return [
    {
      name: "android",
      icon: android
    },
    {
      name: "apple",
      icon: apple
    },
    {
      name: "css3",
      icon: css3
    },
    {
      name: "html5",
      icon: html5
    },
    {
      name: "java",
      icon: java
    },
    {
      name: "javascript",
      icon: javascript
    },
    {
      name: "mongodb",
      icon: mongodb
    },
    {
      name: "nodejs",
      icon: nodejs
    },
    {
      name: "react",
      icon: react
    },
    {
      name: "swift",
      icon: swift
    },
    {
      name: "database",
      icon: database
    }
  ];
}
